/**
 * Newsletter 5% first-order auto-apply (WELCOME5).
 *
 * Shopify Admin → Discounts → Create discount code
 * Code: WELCOME5
 * 5% off order · All products · Do not exclude sale items
 * No minimum · Once per customer if available
 * Combinations: allow product discounts
 * Save
 *
 * Storefront uses /discount/CODE — Cart AJAX cannot apply codes.
 */
(function () {
  const cfg = window.GrowMedicaWelcome5 || {};
  if (cfg.enabled === false) return;

  const CODE = String(cfg.code || 'WELCOME5').trim() || 'WELCOME5';
  const COOKIE = 'discount_code';
  const LS_CODE = 'newsletter_discount';
  const LS_SUB = 'newsletter_subscribed';
  const APPLIED = 'discount_applied';
  const i18n = cfg.i18n || {};

  function shopRoot() {
    const r =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.Theme && window.Theme.routes && window.Theme.routes.root) ||
      '/';
    return String(r).replace(/\/$/, '') || '';
  }

  function setCookie(name, val, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie =
      name + '=' + encodeURIComponent(val) + '; path=/; SameSite=Lax; expires=' + d.toUTCString();
  }

  function getCookie(name) {
    const m = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)')
    );
    return m ? decodeURIComponent(m[1]) : '';
  }

  function persist(code) {
    setCookie(COOKIE, code, 14);
    try {
      localStorage.setItem(LS_CODE, code);
    } catch (e) {}
  }

  function markSubscribed() {
    try {
      localStorage.setItem(LS_SUB, '1');
    } catch (e) {}
  }

  function isSubscribed() {
    try {
      return localStorage.getItem(LS_SUB) === '1';
    } catch (e) {
      return false;
    }
  }

  function discountUrl(code, redirectPath) {
    const root = shopRoot();
    const dest = redirectPath || window.location.pathname + window.location.search;
    return root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest);
  }

  function apply(code, redirectPath) {
    const use = (code || CODE).trim() || CODE;
    persist(use);
    markSubscribed();
    try {
      if (sessionStorage.getItem(APPLIED) === use) return;
      sessionStorage.setItem(APPLIED, use);
    } catch (e) {}
    window.location.assign(discountUrl(use, redirectPath));
  }

  function applyAfterSuccess(uniqueCode) {
    const use = (uniqueCode && String(uniqueCode).trim()) || CODE;
    persist(use);
    markSubscribed();
  }

  function cartHasCode(cart, code) {
    if (!cart) return false;
    const codes = cart.discount_codes || [];
    if (codes.some(function (d) {
      return d && d.code === code && d.applicable !== false;
    })) {
      return true;
    }
    const apps = cart.cart_level_discount_applications || [];
    return apps.some(function (d) {
      return d && (d.title === code || d.code === code);
    });
  }

  function maybeApplyFromCookie() {
    return;
  }

  function uniqueFromKlaviyo(detail) {
    if (!detail) return '';
    const meta = detail.metaData || detail.meta || {};
    return (
      meta.couponCode ||
      meta.uniqueCoupon ||
      meta.shopifyCoupon ||
      detail.couponCode ||
      ''
    );
  }

  const SHOW_AFTER_MS = 45000;
  const HIDE_AFTER_MS = 5000;
  let offerEngaged = false;
  let autoDismissed = false;
  let userOpened = false;
  let autoClosing = false;
  let hideTimer = 0;

  window.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail) return;
    const type = e.detail.type;
    if (type === 'submit' || type === 'stepSubmit' || type === 'redirectedToUrl') {
      applyAfterSuccess(uniqueFromKlaviyo(e.detail));
    }
    if (type === 'close' || type === 'embedClose') {
      scheduleInject();
    }
    if (type === 'open' || type === 'embedOpen' || type === 'close' || type === 'embedClose') {
      syncPopups();
    }
  });

  document.addEventListener(
    'pointerdown',
    function (e) {
      if (autoClosing) return;
      const target = e.target;
      if (!target || !target.closest) return;
      if (target.closest('button.klaviyo-close-form')) {
        const dialog = target.closest('[aria-label="POPUP Form"], [role="dialog"]');
        if (dialog && dialogKind(dialog) === 'offer') {
          autoDismissed = true;
          userOpened = false;
          offerEngaged = false;
          cancelAutoHide();
        }
        return;
      }
      const teaser = target.closest('[class*="kl-teaser-"]');
      if (teaser && isDiscountTeaser(teaser)) {
        userOpened = true;
        offerEngaged = true;
        autoDismissed = false;
        cancelAutoHide();
        return;
      }
      const dialog = target.closest('[aria-label="POPUP Form"]');
      if (dialog && dialogKind(dialog) === 'offer') {
        offerEngaged = true;
        cancelAutoHide();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (
        form.classList.contains('email-signup__form') ||
        form.querySelector('[name="contact[email]"]')
      ) {
        markSubscribed();
        persist(CODE);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      const a = e.target && e.target.closest && e.target.closest('a[href*="/checkout"]');
      if (!a) return;
      const code = getCookie(COOKIE);
      if (!code || a.href.indexOf('discount=') !== -1) return;
      try {
        const u = new URL(a.href, window.location.origin);
        u.searchParams.set('discount', code);
        a.href = u.toString();
      } catch (err) {}
    },
    true
  );

  function isKlaviyoRootCandidate(el) {
    if (!el || el.nodeType !== 1 || !el.matches) return false;
    return el.matches('form[id^="k_id_"], .klaviyo-form, [class*="klaviyo-form"]');
  }

  function insideSignup(el) {
    return !!(el && el.closest && el.closest('.email-signup-block, form.email-signup__form'));
  }

  function insideTeaser(el) {
    return !!(
      el &&
      el.closest &&
      el.closest('[class*="teaser"], [class*="kl-teaser"], [data-testid*="teaser"]')
    );
  }

  function klaviyoRoots() {
    const candidates = document.querySelectorAll(
      'form[id^="k_id_"], .klaviyo-form, [class*="klaviyo-form"]'
    );
    const roots = [];
    candidates.forEach(function (el) {
      if (insideSignup(el) || insideTeaser(el)) return;
      let parent = el.parentElement;
      let nested = false;
      while (parent) {
        if (isKlaviyoRootCandidate(parent)) {
          nested = true;
          break;
        }
        parent = parent.parentElement;
      }
      if (!nested) roots.push(el);
    });
    return roots;
  }

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    const r = el.getBoundingClientRect();
    const s = window.getComputedStyle(el);
    if (r.width <= 8 || r.height <= 8 || s.display === 'none') return false;
    if (s.visibility === 'hidden' && !(el.closest && el.closest('[data-gm-held="1"]'))) return false;
    return true;
  }

  function norm(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function esc(text) {
    return String(text || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function isHealthHeadline(text) {
    const t = String(text || '').toLowerCase();
    const keep = String(i18n.health || '').toLowerCase();
    if (keep && t.indexOf(keep) !== -1) return true;
    return (
      /zdravie\s+m[áa]\s+syst/i.test(t) ||
      /zdraví\s+má\s+syst/i.test(t) ||
      /health has a system/i.test(t) ||
      /gesundheit hat ein system/i.test(t) ||
      /egészségnek rendszere/i.test(t)
    );
  }

  function setStyledText(el, text) {
    const span = el.querySelector('span');
    if (span) span.textContent = text;
    else el.textContent = text;
  }

  function purchasePath() {
    return /\/(products|cart|checkouts?|account|orders)(\/|$)/.test(location.pathname);
  }

  function cookieBannerOpen() {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    const box = banner.getBoundingClientRect();
    const style = window.getComputedStyle(banner);
    return style.display !== 'none' && style.visibility !== 'hidden' && box.width > 40 && box.height > 40;
  }

  function pageBlocked() {
    if (cfg.designMode) return false;
    return purchasePath() || cookieBannerOpen();
  }

  function klaviyoOpened(dialog) {
    if (!dialog || dialog.getAttribute('data-gm-dismissed') === '1') return false;
    const live = dialog.style.getPropertyValue('display');
    const ourHide =
      dialog.getAttribute('data-gm-held') === '1' &&
      dialog.style.getPropertyPriority('display') === 'important' &&
      live === 'none';
    if (!ourHide) {
      if (live === 'none') dialog.setAttribute('data-gm-open', '0');
      else if (live === 'flex' || live === 'block') dialog.setAttribute('data-gm-open', '1');
      else {
        const style = window.getComputedStyle(dialog);
        const box = dialog.getBoundingClientRect();
        if (style.display !== 'none' && Number(style.opacity) !== 0 && box.width > 40 && box.height > 40) {
          dialog.setAttribute('data-gm-open', '1');
        }
      }
    }
    return dialog.getAttribute('data-gm-open') === '1';
  }

  function showOffer(dialog) {
    releaseShell(dialog);
    dialog.style.setProperty('display', 'flex');
    dialog.style.setProperty('visibility', 'visible');
    dialog.style.setProperty('opacity', '1');
    dialog.style.setProperty('pointer-events', 'auto');
    const form = formNode(dialog);
    if (!form) return;
    form.style.setProperty('visibility', 'visible');
    form.style.setProperty('opacity', '1');
    if (form.style.getPropertyValue('display') === 'none') form.style.removeProperty('display');
  }

  function findCloseButton(dialog) {
    const buttons = dialog.querySelectorAll('button.klaviyo-close-form');
    for (let i = 0; i < buttons.length; i++) {
      if (insideTeaser(buttons[i])) continue;
      const label = buttons[i].getAttribute('aria-label') || '';
      if (/teaser/i.test(label)) continue;
      return buttons[i];
    }
    return null;
  }

  function isDiscountTeaser(el) {
    const id = klaviyoFormId(el);
    if (id && BLOCK_FORM_IDS[id]) return false;
    if (id && OFFER_FORM_IDS[id]) return true;
    return /5\s*%|slev|kedvezm|rabatt|zľav|zlav|\boff\b/i.test(norm(el.innerText || ''));
  }

  function isDismissText(text) {
    return /^(ne[, ]|nem[, ]|nein|no[, ]|nie[, ]|kösz|danke|ďakuj|děkuj)/i.test(norm(text));
  }

  function isOfferDialog(dialog) {
    const buttons = dialog.querySelectorAll('button');
    for (let i = 0; i < buttons.length; i++) {
      const text = buttons[i].innerText || '';
      if (isDismissText(text)) continue;
      if (/5\s*%|slev|kedvezm|rabatt|zľav|zlav|\boff\b/i.test(text)) return true;
    }
    return false;
  }

  function popupDialogs() {
    return Array.from(document.querySelectorAll('[role="dialog"]')).filter(function (el) {
      return el.querySelector('.klaviyo-form, form.klaviyo-form, [class*="klaviyo-form"]');
    });
  }

  const OFFER_FORM_IDS = {
    X8jZ3A: 1,
    XXdNxS: 1,
    U3R29k: 1,
    YqYktH: 1,
    SxV9RU: 1
  };
  const BLOCK_FORM_IDS = {
    VYvctC: 1,
    Sj2b7g: 1,
    SBwckj: 1,
    WmCu45: 1,
    URGBLD: 1
  };

  function formNode(dialog) {
    if (!dialog || !dialog.querySelector) return null;
    return dialog.querySelector('[data-testid^="klaviyo-form-"], .klaviyo-form, form.klaviyo-form');
  }

  function klaviyoFormId(el) {
    if (!el) return '';
    const node = el.getAttribute && (el.getAttribute('data-testid') || '').indexOf('klaviyo-form-') === 0
      ? el
      : (el.querySelector ? el.querySelector('[data-testid^="klaviyo-form-"]') : null);
    const testid = node ? node.getAttribute('data-testid') || '' : '';
    if (testid.indexOf('klaviyo-form-') === 0) return testid.slice('klaviyo-form-'.length);
    const cls = String((el.className || '') + ' ' + (el.getAttribute ? el.getAttribute('class') : ''));
    const match = cls.match(/kl-teaser-([A-Za-z0-9]{6})/);
    return match ? match[1] : '';
  }

  function hold(el) {
    if (!el) return;
    if (el.getAttribute('data-gm-held') !== '1') {
      el.setAttribute('data-gm-prev-display', el.style.getPropertyValue('display') || '');
    }
    el.setAttribute('data-gm-held', '1');
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.setAttribute('aria-hidden', 'true');
  }

  function release(el) {
    if (!el || el.getAttribute('data-gm-held') !== '1') return;
    el.setAttribute('data-gm-held', '0');
    const prev = el.getAttribute('data-gm-prev-display') || '';
    if (prev) el.style.setProperty('display', prev);
    else el.style.removeProperty('display');
    el.style.removeProperty('visibility');
    el.style.removeProperty('pointer-events');
    el.removeAttribute('aria-hidden');
  }

  function holdTeaser(el) {
    if (!el) return;
    hold(el);
    el.style.setProperty('display', 'none', 'important');
  }

  function releaseTeaser(el) {
    if (!el) return;
    el.style.removeProperty('display');
    release(el);
  }

  function holdShell(dialog) {
    const form = formNode(dialog);
    if (form) hold(form);
    const parent = dialog.parentElement;
    if (
      parent &&
      parent !== document.body &&
      parent.querySelectorAll('[role="dialog"]').length === 1
    ) {
      const box = parent.getBoundingClientRect();
      if (box.width > window.innerWidth * 0.7 && box.height > window.innerHeight * 0.7) {
        hold(parent);
      }
    }
    hold(dialog);
  }

  function releaseShell(dialog) {
    const form = formNode(dialog);
    if (form) release(form);
    const parent = dialog.parentElement;
    if (parent && parent.getAttribute('data-gm-held') === '1') release(parent);
    release(dialog);
  }

  function dialogKind(dialog) {
    const id = klaviyoFormId(dialog);
    if (id && BLOCK_FORM_IDS[id]) return 'other';
    if (id && OFFER_FORM_IDS[id]) return 'offer';
    if (isOfferDialog(dialog)) return 'offer';
    const buttons = dialog.querySelectorAll('button');
    for (let i = 0; i < buttons.length; i++) {
      const text = norm(buttons[i].innerText || '');
      if (text.length > 2 && !isDismissText(text)) return 'other';
    }
    return 'unknown';
  }

  function teaserNodes() {
    return Array.from(document.querySelectorAll('[class*="kl-teaser-"]')).filter(function (el) {
      if (el.classList && el.classList.contains('gm-k-teaser')) return false;
      return !(el.parentElement && el.parentElement.closest('[class*="kl-teaser-"]'));
    });
  }

  function cancelAutoHide() {
    if (!hideTimer) return;
    window.clearTimeout(hideTimer);
    hideTimer = 0;
  }

  function hideOfferNow() {
    hideTimer = 0;
    if (offerEngaged || userOpened || autoDismissed) return;
    autoDismissed = true;
    autoClosing = true;
    popupDialogs().forEach(function (dialog) {
      if (dialogKind(dialog) !== 'offer') return;
      const btn = findCloseButton(dialog);
      if (btn) btn.click();
      holdShell(dialog);
    });
    window.setTimeout(function () {
      autoClosing = false;
      syncPopups();
    }, 80);
  }

  function scheduleAutoHide() {
    if (hideTimer || offerEngaged || userOpened || autoDismissed) return;
    hideTimer = window.setTimeout(hideOfferNow, HIDE_AFTER_MS);
  }

  function dismissQuiet(dialog) {
    if (!dialog || dialog.getAttribute('data-gm-dismissed') === '1') return;
    const btn = findCloseButton(dialog);
    if (!btn) return;
    dialog.setAttribute('data-gm-dismissed', '1');
    autoClosing = true;
    btn.click();
    window.setTimeout(function () {
      autoClosing = false;
    }, 80);
  }

  function gmOfferHeld() {
    try {
      var until = parseInt(localStorage.getItem('gm_offer_until') || '0', 10);
      if (until && Date.now() < until) return true;
    } catch (e) {}
    var deep = false;
    var height = Math.max(document.documentElement.scrollHeight, 1);
    if ((window.scrollY + window.innerHeight) / height >= 0.5) deep = true;
    var waited = window.performance && performance.now() > 15000;
    return !(waited || deep);
  }

  function syncPopups() {
    const blocked = pageBlocked();
    const onCollection = location.pathname.indexOf('/collections/') === 0;
    let offerVisible = false;
    const dialogs = popupDialogs();
    dialogs.forEach(function (dialog) {
      const kind = dialogKind(dialog);
      const wants = klaviyoOpened(dialog);
      if (kind === 'unknown') return;
      if (kind !== 'offer') {
        holdShell(dialog);
        return;
      }
      if (gmOfferHeld() || blocked || (autoDismissed && !userOpened) || !wants) {
        if (blocked || autoDismissed) holdShell(dialog);
        return;
      }
      showOffer(dialog);
      offerVisible = true;
    });
    if (!autoClosing) {
      dialogs.forEach(function (dialog) {
        if (dialogKind(dialog) === 'other' && klaviyoOpened(dialog)) dismissQuiet(dialog);
      });
    }
    if (offerVisible) {
      try { localStorage.setItem('gm_offer_until', String(Date.now() + 7 * 24 * 60 * 60 * 1000)); } catch (e) {}
    }
    if (offerVisible && !offerEngaged && !userOpened && !autoDismissed) scheduleAutoHide();
    else if (!offerVisible) cancelAutoHide();
    if (offerVisible) scheduleInject();
    const allowIcon = !blocked && !offerVisible;
    let keptDiscount = false;
    teaserNodes().forEach(function (el) {
      if (allowIcon && !onCollection && !keptDiscount && isDiscountTeaser(el)) {
        keptDiscount = true;
        releaseTeaser(el);
      } else {
        holdTeaser(el);
      }
    });
    var klaviyoLock =
      document.body.classList.contains('klaviyo-prevent-body-scrolling') ||
      document.documentElement.classList.contains('klaviyo-prevent-body-scrolling');
    document.documentElement.classList.toggle('gm-popup-scroll-free', !offerVisible && klaviyoLock);
    if (!offerVisible && klaviyoLock) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
      document.documentElement.classList.remove('klaviyo-prevent-body-scrolling');
      document.body.setAttribute('data-gm-scroll-free', '1');
      document.body.style.setProperty('overflow', 'visible', 'important');
      document.documentElement.style.setProperty('overflow', 'visible', 'important');
    } else if (document.body.getAttribute('data-gm-scroll-free') === '1') {
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
      document.body.removeAttribute('data-gm-scroll-free');
    }
  }

  function rewriteKlaviyoCopy() {
    const body = String(i18n.body || '').trim();
    const headline = String(i18n.headline || '').trim();
    if (!body) return;
    klaviyoRoots().forEach(function (root) {
      if (!root.querySelector('input[type="email"]')) return;
      root.querySelectorAll('.gm-welcome5-offer').forEach(function (el) {
        el.remove();
      });
      const paras = Array.from(root.querySelectorAll('p')).filter(function (p) {
        return isVisible(p) && norm(p.innerText);
      });
      if (!paras.length) return;
      let headlineEl = null;
      let bodyEl = null;
      paras.forEach(function (p) {
        const text = norm(p.innerText);
        if (!headlineEl && headline && (isHealthHeadline(text) || text === headline)) {
          if (text !== headline) setStyledText(p, headline);
          p.classList.add('gm-welcome5-offer__headline');
          headlineEl = p;
          return;
        }
        if (!bodyEl) {
          if (text !== norm(body)) {
            p.innerHTML = esc(body).replace(/(5\s*%)/i, '<span class="gm-welcome5-pct">$1</span>');
          }
          bodyEl = p;
          return;
        }
        if (p.classList && p.classList.contains('gm-welcome5-offer__badge')) return;
        p.setAttribute('hidden', '');
        p.style.display = 'none';
      });
      const badgeText = String(i18n.badge || '').trim();
      let badgeEl = root.querySelector('.gm-welcome5-offer__badge');
      if (!badgeEl && badgeText) {
        badgeEl = document.createElement('div');
        badgeEl.className = 'gm-welcome5-offer__badge';
        badgeEl.textContent = badgeText;
        if (headlineEl) headlineEl.insertAdjacentElement('afterend', badgeEl);
        else if (bodyEl) bodyEl.insertAdjacentElement('beforebegin', badgeEl);
      }
      root.setAttribute('data-gm-welcome5-injected', '1');
    });
    syncPopups();
  }

  let injectTimer = 0;
  function scheduleInject() {
    if (injectTimer) return;
    injectTimer = window.setTimeout(function () {
      injectTimer = 0;
      rewriteKlaviyoCopy();
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteKlaviyoCopy);
  } else {
    rewriteKlaviyoCopy();
  }
  const mo = new MutationObserver(function () {
    syncPopups();
    scheduleInject();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(syncPopups, 400);
  window.setTimeout(rewriteKlaviyoCopy, SHOW_AFTER_MS);
  window.setTimeout(rewriteKlaviyoCopy, SHOW_AFTER_MS + 400);

  if (cfg.justSubscribed) {
    applyAfterSuccess(cfg.uniqueCode);
  }

  const params = new URLSearchParams(window.location.search);
  if (params.get('test_welcome5') === '1' && cfg.designMode) {
    markSubscribed();
    persist(CODE);
    maybeApplyFromCookie();
  } else {
    maybeApplyFromCookie();
  }
})();
